
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
@Component({})
export default class DailyReportBudgetSheet extends Vue {
    @Prop({ default: () => [] })
    rows!: Array<any>;
    @Prop({default:false}) isEditingDailyReport!:boolean;
    forceReload = 0;

    updateLineSum(activityId: any, dailyCost: any, item: any) {
      const id = item.id;
      this.$emit('lineValueChanged', {id, activityId, dailyCost})
    }
    calculateDailyCostTotal(budgetLineItems:any) {
      return budgetLineItems.reduce(
        (acc:any, item:any) => acc + parseFloat(item.dailyCost || 0),
        0
      );
    }

    calculateTotal(budgetLineItems:any) {
      return budgetLineItems.reduce(
        (acc:any, item:any) => acc + parseFloat(item.lineSum || 0),
        0
      );
    }

    calculateTotalForOperationUnit(operationunit: string) {
      return this.formattedData
        .filter(row => row.operationunit === operationunit)
        .flatMap(row => row.budgetLineItems)
        .reduce((acc, item) => acc + parseFloat(item.dailyCost || 0), 0);
    }

    calculateTotalLineSumForOperationUnit(operationunit: string) {
      return this.formattedData
        .filter(row => row.operationunit === operationunit)
        .flatMap(row => row.budgetLineItems)
        .reduce((acc, item) => acc + parseFloat(item.lineSum || 0), 0);
    }

    calculateTotalForDepartment(department: string) {
      return this.formattedData
        .filter(row => row.department === department)
        .flatMap(row => row.budgetLineItems)
        .reduce((acc, item) => acc + parseFloat(item.dailyCost || 0), 0);
    }

    calculateTotalLineSumForDepartment(department: string) {
      return this.formattedData
        .filter(row => row.department === department)
        .flatMap(row => row.budgetLineItems)
        .reduce((acc, item) => acc + parseFloat(item.lineSum || 0), 0);
    }

    get formattedData() {
      const budget = this.rows.map((item: any) => ({
        activityId: item.activityId,
        department: item.department,
        milestone: item.milestone,
        operationunit: item.operationunit,
        section: item.section,
        budgetLineItems: item.section.budgetLineItems.map((line: any) => {
          const matchingLine = item.budgetLinesForMilestone.find((x: any) => String(x.lineItemId) === String(line.id));
          const lineItemToSum = item.allReportByActivity.filter((x:any) => x && x.lineItemId === line.id);
          let totalLineValue = 0;
          if (lineItemToSum && lineItemToSum.length > 0) {
            totalLineValue = lineItemToSum.reduce((sum: number, currentItem: any) => {
              return sum + (currentItem.lineValue || 0);
            }, 0);
          }
          return {
            ...line,
            dailyCost: matchingLine ? matchingLine.lineValue : line.dailyCost || 0,
            lineSum: totalLineValue,
            allReportByActivity: item.allReportByActivity
          };
        }),
      }));

      return budget;
    }

    mounted() {
      this.forceReload += 1;
    }
}
